import { Progress } from '@agro-club/agroclub-shared'
import { RequestError } from 'modules/errors'
import { useState } from 'react'
import { useIsMounted } from './useIsMounted'
import axios from 'axios'
import { useNoPermissionNotification } from './useNoPermissionNotification'

export const useProgress = <T, Args extends any[] = any[]>(
  request: (...args: Args) => Promise<T | undefined>,
): [Progress, typeof request, ReturnType<typeof RequestError.parseError> | null] => {
  const [progress, setProgress] = useState(Progress.IDLE)
  const [error, setError] = useState<ReturnType<typeof RequestError.parseError> | null>(null)
  const notify = useNoPermissionNotification()
  const isMounted = useIsMounted()

  const sendRequest = async (...args: Args) => {
    setProgress(Progress.WORK)

    try {
      const response = await request(...args)
      if (isMounted.current) setProgress(Progress.SUCCESS)
      setError(null)

      return response
    } catch (error) {
      if (!axios.isCancel(error)) {
        setError(RequestError.parseError(error))
        setProgress(Progress.ERROR)
        const err = error as RequestError | undefined
        if (err?.code === 403) {
          notify(err.url)
        }
        throw error
      }
    }
  }
  return [progress, sendRequest, error]
}
